import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=ddba9d98&scoped=true"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddba9d98",
  null
  
)

export default component.exports